module.exports = __webpack_public_path__ + "static/media/SWSCRC6-37.123d089e.mp3";